export const HIDE_SIGNAL = 'hide';

export const HOME_SIGNAL = 'home';
